import React from 'react'
import map from 'lodash/map'
import type { PositiveCountOptionEnum } from '@ztechapps/common.hook'
import type { TableFilterProps } from './types'
import { RadioInputGroup } from '@ztechapps/webui.input'
import { useTableFilterContext } from './Context'
import { FilterContainerBodyLayout } from './FilterContainer'
import { filterToPositiveCountOption, positiveCountOptionToFilter } from './positiveCountFilter.utils'

export const PositiveCountTableFilter = ({ field }: TableFilterProps) => {
  const { onFilter, getStoredFilter, setShowFilterContainer } = useTableFilterContext()
  const option = filterToPositiveCountOption(getStoredFilter())
  const options = map(field.fieldSettings?.listValues, ({ value, title }) => ({ value, label: title }))

  const onChange = (value: PositiveCountOptionEnum) => {
    onFilter({ [field.name]: positiveCountOptionToFilter(value) })
    setShowFilterContainer(false)
  }

  return (
    <FilterContainerBodyLayout>
      <RadioInputGroup
        name={`${field.name}PositiveCountOptions`}
        options={options}
        value={option ?? ''}
        onChange={(e) => onChange(e.target.value as PositiveCountOptionEnum)}
      />
    </FilterContainerBodyLayout>
  )
}
